export const blockIconsSocialQuizNew = (
	<span className='material-symbols-outlined'>quiz</span>
);
